{
	"submitTitle": "Vyberte materiál",
	"summary": {
		"title": "Shrnutí",
		"declarationTypeTitle": "Typ prohlášení",
		"projectReferenceTitle": "Reference projektu"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Vyberte typ deklarace",
			"customerProject": {
				"title": "Zákaznický projekt",
				"description": "Materiál byl použit pro externí projekt. Nyní musím poskytnout prohlášení s podrobným popisem snížení uhlíku pro mého zákazníka."
			},
			"internalProjectOrProduct": {
				"title": "Interní projekt / produkt",
				"description": "Materiál byl použit pro interní projekt nebo produkt. Potřebuji vytvořit prohlášení, abych požadoval snížení uhlíku pro naše vlastní operace."
			}
		},
		"addProjectReferenceSection": {
			"title": "Přidejte odkaz na projekt",
			"subTitle": "Referenci projektu, pro kterou chcete vytvořit prohlášení, musíte přiřadit snížení uhlíku.",
			"projectReferencePlaceholder": "Reference projektu"
		},
		"selectProjectSection": {
			"title": "Vyberte projekt",
			"createNewProjectPlaceholder": "Vytvořit nový projekt"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Je vyžadován typ prohlášení",
		"projectReferenceRequired": "Je vyžadována reference projektu",
		"fetchProjectsError": "Nepodařilo se načíst předchozí projekty"
	}
}
